import { debugLog } from "./debugLog";

export function getFaviconUrl() {
  const iconLink = document.querySelector('link[rel~="icon"]');
  let url = window.location.host + '/favicon.ico'
  url = url.includes("localhost")? 'http://' + url : url;
  url = url.startsWith("http")? url : 'https://' + url;
  return iconLink ? iconLink.href : url;
}

function valueCheck(functionName, value, expectedValue) {
  if (typeof value !== expectedValue) {
    throw new Error(`${functionName} function expected ${expectedValue} as one of its parameters.`);
  }
}

export function isCoinsubDomain() {
  return window.location.host.includes("coinsub.io");
}

export function countDecimals (value) {
  const inputValue = Number(value);
  valueCheck('countDecimals', inputValue, 'number');

  if (Math.floor(value) !== value) {
    return value.toString().split(".")[1].length || 0;
  }
  return 0;
}

/**
 * @param {String} url URL to normalize
 * @returns {String} normalized url
 */
export function normalizeURL(url) {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

/**
 * @param {Number} seconds Number of seconds to format
 * @returns {String} String of the format "5:30"
 */
export function formatTimer(seconds) {
  if (!seconds || seconds < 0 || typeof seconds !== 'number') {
    return "0:00";
  }

  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${sec.toString().padStart(2, '0')}`;
}

/**
 * @param {String} email Email to validate
 * @returns {Boolean} True if the email is valid, false otherwise
 */
export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * @param {String} address Ethereum address to validate
 * @returns {Boolean} True if the address is a valid Ethereum address, false otherwise
 */
export function validateEthereumAddress(address) {
  // Ethereum address regex: 0x followed by 40 hexadecimal characters
  const ethereumAddressRegex = /^0x[a-fA-F0-9]{40}$/;
  return ethereumAddressRegex.test(address);
}

export function debounce(fn,timeout=300) {
  let timer;
  return (...args) => {
    if (!timer) {
      fn.apply(this, args);
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = undefined;
    }, timeout);
  };
}

export { debugLog, debugError } from './debugLog';
